import { Controller } from "@hotwired/stimulus";

export default class IndexController extends Controller {
    // nothing here
}